import defaultState, { DialInReducer } from './defaultState'
import { ReduxAction } from '../reducerType'
import { DialInType } from '../../actions/dialIn/dialInTypes'

export default function (state: DialInReducer = defaultState, { type, payload }: ReduxAction): DialInReducer {

  switch (type) {

    case DialInType.FETCH_DIAL_IN_CODE:
      return { ...state, codeFetchStatus: 'fetching' }
    case DialInType.FETCH_DIAL_IN_CODE_ERROR:
      return { ...state, codeFetchStatus: 'error' }
    case DialInType.FETCH_DIAL_IN_CODE_SUCCESS:
      return { ...state, codeFetchStatus: 'complete' }
    case DialInType.SET_PARTICIPANT_CODE:
      return { ...state, code: payload }
    case DialInType.FETCH_DIAL_IN_PHONE_NUMBERS:
      return { ...state, phoneNumberFetchStatus: 'fetching' }
    case DialInType.FETCH_DIAL_IN_PHONE_NUMBERS_ERROR:
      return { ...state, phoneNumberFetchStatus: 'error' }
    case DialInType.FETCH_DIAL_IN_PHONE_NUMBERS_SUCCESS:
      return { ...state, phoneNumberFetchStatus: 'complete' }
    case DialInType.SET_DIAL_IN_PHONE_NUMBERS:
      return { ...state, phoneNumbers: payload }
    case DialInType.SET_SELECTED_DIAL_IN_PHONE_NUMBER:
      return { ...state, selectedPhoneNumber: payload }
    default:
      return state

  }

}
